export const swapObjectKeysValues = (data: any) => {
  try {
    return (
      Object.entries(data).reduce(
        (acc, [key, value]: any) => ((acc[value] = key), acc),
        {},
      ) || {}
    )
  } catch {
    return {}
  }
}
